/**
 * Русский каталог текстов для функции `community` (форумы, ветки, Зал Легенд).
 * Ключи отражают вызовы `t('community.*')` в packages/@gamecodex/world-ui/src/features/community.
 */
export const communityRu = {
  // CommunityPage
  'community.page.seoTitle': 'Сообщество',
  'community.page.seoDescription':
    'Присоединитесь к сообществу Grymwyrd: форумы, теории лора, инструменты Мастера, домашние правила и Зал Легенд.',
  'community.page.eyebrow': 'Собирается Мрак',
  'community.page.title': 'Сообщество',
  'community.page.intro':
    'Обменивайтесь тактикой, строите теории, делитесь домашними правилами и поднимайтесь к канону. Каждое ваше сообщение приносит монеты и репутацию в вечные сумерки.',
  'community.page.loading': 'Собираем верных…',
  'community.page.forumCategories': 'Категории Форума',
  'community.page.categoryStats': '{threads} ветки · {posts} сообщений',
  'community.page.recentActivity': 'Недавняя Активность',
  'community.page.liveFeed': 'живая лента',
  'community.page.recentEmpty':
    'Сегодня форумы молчат. Начните дискуссию, чтобы разбудить мертвецов.',
  'community.page.hallOfLegends': 'Зал Легенд',
  'community.page.hallBlurb': 'Величайшие участники и персонажи, которых они ковали в канон.',
  'community.page.enterTheHall': 'Войти в Зал',
  'community.page.playerSpotlights': 'Прожектор на Игроков',
  'community.page.summoningLegends': 'Вызываем легенды…',
  'community.page.sampleNotice': 'Показываем образец контента сообщества, пока живые форумы пробуждаются.',

  // FlagButton
  'community.flag.errorQueued':
    'Мы не смогли связаться с модераторами сейчас, но ваш отчет был поставлен в очередь.',
  'community.flag.ariaLabel': 'Пожаловаться на это сообщение модератору',
  'community.flag.label': 'Пожаловаться',
  'community.flag.modalTitle': 'Сообщить Хранителям',
  'community.flag.successDelivered':
    'Ваш отчет доставлен модераторам. Хранители вам благодарны.',
  'community.flag.close': 'Закрыть',
  'community.flag.signInNotice':
    'Вы можете описать проблему, но должны быть авторизованы, чтобы отчет дошел до модераторов.',
  'community.flag.whyFlagging': 'Почему вы жалуетесь на это?',
  'community.flag.reason.spamOrAdvertising': 'Спам или реклама',
  'community.flag.reason.harassmentOrAbuse': 'Преследование или оскорбление',
  'community.flag.reason.spoilersWithoutWarning': 'Спойлеры без предупреждения',
  'community.flag.reason.offTopic': 'Не по теме',
  'community.flag.reason.otherDescribeBelow': 'Другое (опишите ниже)',
  'community.flag.describeIssue': 'Опишите проблему',
  'community.flag.detailPlaceholder': 'Расскажите Хранителям, что не так…',
  'community.flag.cancel': 'Отмена',
  'community.flag.reporting': 'Отправляем…',
  'community.flag.submitReport': 'Отправить отчет',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — Форумы',
  'community.category.seoDescription': 'Дискуссии в форуме {name} на Grymwyrd.',
  'community.category.breadcrumb': 'Сообщество',
  'community.category.entityTiedPrefix': 'Доска, привязанная к существу · ветки могут ссылаться на',
  'community.category.encyclopediaEntries': 'статьи энциклопедии',
  'community.category.sampleNotice': 'Показываем образец веток, пока живой форум пробуждается.',

  // HallOfLegendsPage
  'community.legends.seoTitle': 'Зал Легенд',
  'community.legends.seoDescription':
    'Величайшие участники Grymwyrd и персонажи, которых они ковали в канон.',
  'community.legends.breadcrumb': 'Сообщество',
  'community.legends.title': 'Зал Легенд',
  'community.legends.intro':
    'Здесь стоят зодчие вечных сумерек — участники, чьи слова стали законом, и персонажи, столь любимые, что были высечены в камень канона.',
  'community.legends.loading': 'Зажигаем свечи…',
  'community.legends.topContributors': 'Лучшие Участники',
  'community.legends.noContributors':
    'Легенды еще не восстали. Пишите, создавайте теории и творите, чтобы занять свое место.',
  'community.legends.canonizedCharacters': 'Канонизированные Персонажи',
  'community.legends.noCharacters':
    'Персонажи еще не канонизированы. Бестиарий ждет своего следующего ужаса.',
  'community.legends.sampleNotice': 'Показываем образец легенд, пока живой зал освящается.',

  // NestedReplies
  'community.replies.replyBy': 'Ответ от {author}',
  'community.replies.reply': 'Ответить',
  'community.replies.replyToPlaceholder': 'Ответить {author}…',
  'community.replies.unlike': 'Убрать лайк этому сообщению',
  'community.replies.like': 'Лайкнуть это сообщение',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} репутации',
  'community.spotlight.viewInEncyclopedia': 'Посмотреть {name} в энциклопедии',

  // PostComposer
  'community.composer.placeholder': 'Добавьте свой голос во мрак…',
  'community.composer.signInPrompt': 'Авторизуйтесь, чтобы присоединиться к дискуссии и получить монеты за свои слова.',
  'community.composer.signInToReply': 'Авторизуйтесь, чтобы ответить',
  'community.composer.youFallback': 'Вы',
  'community.composer.saveError':
    'Ваш ответ не сохранен на сервере — отображается только локально.',
  'community.composer.writeReply': 'Напишите ответ',
  'community.composer.writePost': 'Напишите сообщение',
  'community.composer.replyText': 'Текст ответа',
  'community.composer.postText': 'Текст сообщения',
  'community.composer.posting': 'Отправляем…',
  'community.composer.postReply': 'Отправить ответ',
  'community.composer.post': 'Отправить',
  'community.composer.cancel': 'Отмена',
  'community.composer.coinsPerPost': '+{count} монет за сообщение',
  'community.composer.coinsEarned': '+{count} монет получено за ваше сообщение!',

  // ThreadItem
  'community.thread.pinned': 'Закрепленная ветка',
  'community.thread.byPrefix': 'от',
  'community.thread.repliesTitle': '{count} ответов',
  'community.thread.likesTitle': '{count} лайков',
  'community.thread.viewsTitle': '{count} просмотров',
  'community.thread.entityEntry': 'статья {type}',

  // ThreadList
  'community.threadList.empty':
    'Никакие дискуссии здесь еще не велись. Будьте первым, кто нарушит тишину.',

  // ThreadPage
  'community.threadPage.loading': 'Раскрываем ветку…',
  'community.threadPage.seoDescription': 'Дискуссия в форумах сообщества Grymwyrd.',
  'community.threadPage.replyCount': '{count} ответов',
  'community.threadPage.opened': 'открыто {time}',
  'community.threadPage.entityEntry': 'статья {type}',
  'community.threadPage.sampleNotice': 'Показываем образец дискуссии, пока живой форум пробуждается.',
  'community.threadPage.openingPostBy': 'Первое сообщение от {author}',
  'community.threadPage.repliesHeading': 'Ответы',
  'community.threadPage.noReplies': 'Ответов еще нет. Будьте первым, кто откликнется.',
  'community.threadPage.addYourReply': 'Добавьте свой ответ',
} as const
